import { useState } from 'react';
import { SnowfallSettings } from '../types/snowfall-settings.type';

const defaultSettings: SnowfallSettings = {
  color: '#DEE4FD',
  snowflakeCount: 75,
  radius: [10, 25], // [10, 25] for images, [0.5, 3] default
  speed: [0.5, 2.0],
  wind: [-0.5, 2.0],
  rotationSpeed: [-1.0, 1.0],
  useImages: true,
};

export const useSnowfallSettings = () => {
  const [snowfallSettings, setSnowfallSettings] = useState<SnowfallSettings>(defaultSettings);

  return { snowfallSettings, setSnowfallSettings };
};
